// extracted by mini-css-extract-plugin
export default {"styledTooltipFont":"claoR"};